const getURLParam = (paramName: string): string => {
  const url = new URL(window.location.href);
  const paramValue = url.searchParams.get(paramName);
  return paramValue ?? '';
};

export default getURLParam;
